export default {"src":"/_next/static/media/gift.215cf0cc.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};